export enum FacingModeType {
    ENVIRONMENT = 'environment',
    USER = 'user'
}